
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleaning",
      function () {
        return require("private-next-pages/cleaning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleaning"])
      });
    }
  